import styled from "styled-components"

export const FilterOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 150px;
  overflow: auto;
`

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SeverityLevelContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`

export const NotificationStatusContainer = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
`

export const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 0;
`

export const WhoActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`

export const TextCount = styled.span`
  font-size: 12px;
  color: ${({ length }) => (length > 160 ? '#BE3756' : '#666E7B')};
`
